// extracted by mini-css-extract-plugin
export default {"imagePatient":"PatientImage_imagePatient__uuTqN","imagePatientIMG":"PatientImage_imagePatientIMG__OfTcT"};